/**
 * @generated SignedSource<<acf7e55b7b68ea87267b36d7a8a42c0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$data = {
  readonly issueLink: {
    readonly relationName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView";
};
export type ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$key = {
  readonly " $data"?: ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView",
  "selections": [
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationName"
        }
      ]
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "99eeee1e19009209c4cbc431eef50271";

export default node;
